const G_formatField = (res) => {
    let _obj = res || {}
    let _done = {}
    for (let key in _obj) {
        _done[key] = { value: _obj[key] }
    }
    return _done
}
const CHANGE_FILE_VALUE = 'CHANGE_FILE_VALUE'
const RESET_FILE_VALUE = 'RESET_FILE_VALUE'

const initState = { }
export const formDataValue = (state=initState,action)=>{
    switch (action.type) {
        case CHANGE_FILE_VALUE: return {...state,...action.payload}
        case RESET_FILE_VALUE: return {...initState}
        default: return {...state}
    }
}

export const Redux_superForm_change= (form,superForm)=>{
    if(superForm === 'superForm'){
        return {type:CHANGE_FILE_VALUE, payload:form}
    }else{
        return {type:CHANGE_FILE_VALUE, payload:G_formatField(form)}
    }
}
export const Redux_superForm_reset = () =>{
    return { type: RESET_FILE_VALUE }
}


// WEBPACK FOOTER //
// ./src/reducer/superFrom.redux.js